module.exports = __webpack_public_path__ + "static/slackMeetSmallchat.eac0477a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/slackMeetSmallchat.svg
// module id = 508
// module chunks = 35783957827783